import { useState, useEffect } from 'react';
import { fieldValidator } from '../../utils/yupSchemaCreator';
import { Select, FormControl } from '@airbus/components-react';

export default function FieldBool(props) {
  const { rowId, initialValues, name, label, required, disabled, blurHandler, field, language } =
    props;
  const [value, setValue] = useState(initialValues[name]?.toString?.() ?? null);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);
  const options = [
    { label: 'false', value: 'false' },
    { label: 'true', value: 'true' },
  ];

  useEffect(() => {
    if (initialValues) {
      setValue(initialValues[name]?.toString?.() ?? null);
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }
      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const error = fieldValidator(field, newValue, language);
    setValue(newValue);
    setError(error);
    blurHandler(name, /^true$/i.test(newValue));
    if (field?.onValueChange) {
      field.onValueChange({ rowId, value, row: initialValues });
    }
  };
  return (
    <FormControl
      {...{
        disabled,
        required,
        label,
        name,
      }}
      id={name}
      error={touched && Boolean(error)}
      helpText={touched && error?.msg}
      errorText={touched && error?.msg}
    >
      <Select
        {...{ name, disabled }}
        mode='AUTO'
        size='small'
        options={options}
        value={value ?? ''}
        onChange={handleChange}
      ></Select>
    </FormControl>
  );
}
